import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

const Keyword = ({ content }) => {
    return (
        <div className={styles.keyword}>
            <div className={styles.keywordHead}>今日关键词</div>
            <div className={styles.keywordText}>{ content }</div>
        </div>
    );
};

Keyword.propTypes = {
    content: PropTypes.string,
};

export default errorBoundary(Keyword);
